export default "__VITE_ASSET__Ce1gBqRu__"